import { Clickable, Col, Icon, Row, Text } from 'components';
import { Api } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const ImageBackground = styled.div`
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 184px;
  width: 184px;
  padding: 16px;
  justify-content: space-between;

  ${(props) =>
    props.sidebar &&
    `
    height: 100%;
    width: 100%;
    padding: 0;
  `}
`;

const Item = ({ item, follow, navigate, subtitleText, removeSuggestion, allUsers }) => {
  const [loading, setLoading] = useState(false),
    { following } = useSelector((state) => state.user),
    isFollowing = following?.find((x) => x?._id || x === item._id),
    dispatch = useDispatch(),
    { t } = useTranslation();

  if (!item) return null;

  async function follow(e) {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;
    setLoading(true);

    await Api.post(isFollowing ? '/users/unfollow' : '/users/follow', { userId: item._id });

    dispatch({
      type: isFollowing ? 'UNFOLLOW' : 'FOLLOW',
      payload: item
    });

    setLoading(false);
  }

  return (
    <Col noFlex>
      <Clickable onClick={(e) => navigate(`/profile/${item.username}`)}>
        <ImageBackground src={item.avatar}>
          <Col ht="100%" between>
            <Row between noFlex>
              <Col />

              {!allUsers && (
                <Clickable onClick={() => removeSuggestion(item)}>
                  <Row
                    wid="32px"
                    ht="32px"
                    bg="rgba(210, 216, 223, 0.7)"
                    hasRadius="48px"
                    centerAll
                  >
                    <Icon type="close" dimensions={14} />
                  </Row>
                </Clickable>
              )}
            </Row>

            {/* item.type === 'fan' && (
              <Clickable onClick={() => follow(item)} style={{ zIndex: 3 }}>
                <Row
                  wid='184px'
                  ht='32px'
                  bg='rgba(210, 216, 223, 0.7)'
                  hasRadius='48px'
                  centerAll
                >
                  <Text b2 bold>{isFollowing ? t('common.unfollow') : t('common.follow')}</Text>
                </Row>
              </Clickable>
            )*/}
          </Col>
        </ImageBackground>
      </Clickable>

      <Col marg="8px 0 0">
        <Text b1 med>
          {item.name}
        </Text>

        <Text b2 ht="18px" wid="216px" hideOverflow>
          {typeof subtitleText === typeof (() => null)
            ? subtitleText(item)
            : subtitleText || item.bio}
        </Text>
      </Col>
    </Col>
  );
};

export default Item;
